import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import Text from 'components/elements/text';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function OtherFeesTable() {
  const { t } = useTranslation();
  const name: any = 'approvalable.productPurchaseOtherFees';
  const value = HOCWatchValue({ keys: [name] });
  const data = value[name];

  const columns = [
    {
      header: t('common:name'),
      accessorKey: 'name',
      minSize: 200,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:description'),
      accessorKey: 'description',
      minSize: 400,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 200,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];
  return (
    <div style={{ width: '100%' }}>
      <Text variant="ParagraphMedium">{t('common:other_fees')}</Text>
      <SeparatorVertical $margin={16} />
      <TableEditableComponent
        columns={columns}
        data={data}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
